import type { PropertyFilters } from '~/core/entities/property/filters';

import { PropertyFiltersPresenter } from '~/presenters/PropertyFiltersPresenter';

/**
 * Filters for "an agent's exclusive listings". No location: the profile shows
 * the agent's exclusives in any city, and the API searches without one.
 */
export function buildAgentExclusivePropertiesFilters(
	agentSlug: string
): PropertyFilters {
	return {
		transactionType: 'sell',
		agentSlug,
		isExclusive: true
	};
}

/**
 * SRP already filtered by agent and exclusivity. The SRP cannot search without
 * a location, so the presenter puts the default one (São Paulo) in the path;
 * for an agent outside it, that list can be shorter than the carousel.
 */
export function buildAgentExclusivePropertiesSrpPath(
	agentSlug: string
): string {
	if (!agentSlug) return '';

	return PropertyFiltersPresenter.getPathFromFilters(
		buildAgentExclusivePropertiesFilters(agentSlug)
	);
}
